<div class="comment-wrapper">
  <div class="comment animated" [class.zoomIn]="showInfoModal">
    <div class="comment-header">
      <h3>More Info</h3>
    </div>
    <div class="comment-body">
      <form [formGroup]="newCommentsFG">
        <div class="comment-container" formArrayName="commentsArray">
          <ng-container *ngFor="let comment of comments; let i = index" [ngStyle]="i!==0 && {'margin-top': '30px'}"
            [formGroupName]="i">
            <div class="comment-input">
              <textarea rows="4" formControlName="comment" id="comment"
              [style.opacity]="adminOrVendorManger ? 1 : 0.5"
              ></textarea>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
    <div class="comment-footer" *ngIf="adminOrVendorManger">
      <button type="button" class="comment-footer__button cancel" (click)="closeCommentModal()">Cancel</button>
      <button type="button" class="comment-footer__button save" (click)="patchComment()">Save</button>
    </div>
    <div class="comment-footer" *ngIf="!adminOrVendorManger">
      <button type="button" class="comment-footer__button save" (click)="closeCommentModal()">Got it</button>
    </div>
  </div>
</div>